export default "__VITE_ASSET__D9WZXhe1__"